import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = () => {
  const location = useLocation();
  const isProd = process.env.REACT_APP_ENV === "PROD"; // ✅ Corrected env variable

  useEffect(() => {
    if (isProd && window.gtag) {
      window.gtag("config", "G-3GD5Q0QKSY", {
        page_path: location.pathname,
      });
    }
  }, [location, isProd]);
};

export default usePageTracking;
